import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import './UpgradeModal.css';

function UpgradeModal({ isOpen, onClose }) {
    const [isLoading, setIsLoading] = useState(false);

    if (!isOpen) return null;

    const CYCLE_URL = process.env.REACT_APP_STRIPE_LINK_CYCLE || "https://buy.stripe.com/cNi4gsgh61fzdxu9xG8AE04";
    const LIFETIME_URL = process.env.REACT_APP_STRIPE_LINK_LIFETIME || "https://buy.stripe.com/7sYbIU9SIe2l50Y4dm8AE03";

    const handleCheckout = async (planType) => {
        setIsLoading(true);

        try {
            const { data: { user } } = await supabase.auth.getUser();

            if (!user) {
                alert("Please log in to upgrade your account.");
                setIsLoading(false);
                return;
            }

            const baseUrl = planType === 'lifetime' ? LIFETIME_URL : CYCLE_URL;
            // Append the Client Reference ID so the Webhook knows WHO paid
            const finalUrl = `${baseUrl}?client_reference_id=${user.id}`;
            
            // Redirect
            window.location.href = finalUrl;

        } catch (error) {
            console.error("Checkout Error:", error);
            alert("Something went wrong initializing checkout. Please try again.");
            setIsLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="upgrade-modal-card" onClick={e => e.stopPropagation()}>
                <div className="upgrade-header">
                    <h2>Unlock Full Access</h2>
                    <p>Master the bar with unlimited access to all subjects, rules, and our adaptive learning system.</p>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>

                <div className="pricing-grid">
                    {/* OPTION 1: CYCLE PASS */}
                    <div className="pricing-card">
                        <div className="price-header">
                            <h3>Cycle Pass</h3>
                            <div className="price-tag">
                                <span className="price-amount">$199</span>
                            </div>
                        </div>
                        <ul className="features-list">
                            <li>All 15 UBE Subjects</li>
                            <li>~1,200 Black Letter Law Rules</li>
                            <li>300+ Mini-Essays</li>
                            <li>De Novo&trade; Spaced Repetition</li>
                        </ul>
                        <button 
                            className="btn btn-secondary full-width" 
                            onClick={() => handleCheckout('cycle')}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Processing...' : 'Select Cycle Pass'}
                        </button>
                    </div>

                    {/* OPTION 2: LIFETIME */}
                    <div className="pricing-card featured">
                        <div className="badge">Best Value</div>
                        <div className="price-header">
                            <h3>Lifetime Access</h3>
                             <div className="price-tag">
                                <span className="price-amount">$249</span>
                            </div>
                        </div>
                        <ul className="features-list">
                            <li><strong>Everything in Cycle Pass</strong></li>
                            <li>Unlimited Retake Guarantee</li>
                            <li>All Future Content Updates</li>
                            <li>iOS Beta (coming soon)</li>
                        </ul>
                        <button 
                            className="btn full-width" 
                            onClick={() => handleCheckout('lifetime')}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Processing...' : 'Get Lifetime Access'}
                        </button>
                    </div>
                </div>
                
                <p className="footer-note">Secure payment via Stripe. 3-day money-back guarantee.</p>
            </div>
        </div>
    );
}

export default UpgradeModal;